import { createFileRoute } from '@tanstack/react-router'

import { CampaignDetailPage } from '@/features/campaigns'

export const Route = createFileRoute('/_authenticated/_main/campanhas/$campaignId')({
  component: RouteComponent
})

function RouteComponent() {
  const { campaignId } = Route.useParams()
  return <CampaignDetailPage campaignId={Number(campaignId)} />
}
